module.exports = __webpack_public_path__ + "static/media/image_46.c1b014fd.png";